import actions from 'actions/formTemplates'
import { createChildFormViewContainer } from 'factories/ChildFormView'
import Component from 'components/FormTemplates/FormView/SectionForm'

export default createChildFormViewContainer({ actions })(Component)
